import { LessonIcon } from 'foundations-assets/icons/components/LessonIcon';
import { TableIcon } from 'foundations-assets/icons/components/TableIcon';
import { PdfFileIcon } from 'foundations-assets/icons/components/PdfFileIcon';
import { VolumeUpIcon } from 'foundations-assets/icons/components/VolumeUpIcon';
import { VideoIcon } from 'foundations-assets/icons/components/VideoIcon';
import { PresentationIcon } from 'foundations-assets/icons/components/PresentationIcon';
import { InsertImageIcon } from 'foundations-assets/icons/components/InsertImageIcon';
export const FILE_TYPE_ICONS = [{
  mimeTypes: ['image/*'],
  extensions: ['gif', 'jpeg', 'jpg', 'png', 'tiff'],
  icon: InsertImageIcon
}, {
  mimeTypes: ['application/pdf'],
  extensions: ['pdf'],
  icon: PdfFileIcon
}, {
  mimeTypes: ['video/*'],
  extensions: ['mp4', 'mov', 'avi', 'mkv', 'webm'],
  icon: VideoIcon
}, {
  mimeTypes: ['audio/*'],
  extensions: ['mp3', 'wav', 'ogg', 'aac'],
  icon: VolumeUpIcon
}, {
  mimeTypes: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.oasis.opendocument.presentation'],
  extensions: ['ppt', 'pptx', 'odp'],
  icon: PresentationIcon
}, {
  mimeTypes: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.oasis.opendocument.spreadsheet', 'text/csv'],
  extensions: ['xls', 'xlsx', 'csv', 'ods'],
  icon: TableIcon
}, {
  mimeTypes: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.oasis.opendocument.text', 'text/plain'],
  extensions: ['doc', 'docx', 'odt', 'txt'],
  icon: LessonIcon
}];
export const getFileTypeIcon = ({
  mimeType,
  fileName,
  ext
}) => {
  var _fileName$split$pop;
  const fileExtension = ext ? ext.toLowerCase() : fileName ? ((_fileName$split$pop = fileName.split('.').pop()) === null || _fileName$split$pop === void 0 ? void 0 : _fileName$split$pop.toLowerCase()) || '' : '';
  for (const fileType of FILE_TYPE_ICONS) {
    const mimeMatches = fileType.mimeTypes.some(type => {
      if (type.endsWith('/*')) {
        const prefix = type.slice(0, -2);
        return mimeType.startsWith(prefix);
      }
      return type === mimeType;
    });
    const extensionMatches = fileType.extensions.includes(fileExtension);
    if (mimeMatches || extensionMatches) {
      return fileType.icon;
    }
  }
  return LessonIcon;
};
export const ACCEPTED_FILE_TYPES = ['video/*', 'audio/*', 'application/json', 'application/vnd.ms-excel', 'application/vnd.ms-powerpoint', 'application/msword', 'application/pdf', 'application/zip', 'application/x-zip', 'application/x-gzip', 'application/x-zip-compressed', 'application/x-7z-compressed', 'application/gzip', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.oasis.opendocument.graphics', 'application/vnd.oasis.opendocument.presentation', 'application/vnd.oasis.opendocument.spreadsheet', 'application/vnd.oasis.opendocument.text', 'image/gif', 'image/jpeg', 'image/jpg', 'image/png', 'image/tiff', 'text/calendar', 'text/css', 'text/csv', 'text/plain', 'message/rfc822'];
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB